const state = {
    responsibilities: [],
};

const mutations = {
    setResponsibilities(state, value) {
        state.responsibilities = value;
    },
};

const actions = {};

const getters = {
    responsibilities: (state) => state.responsibilities,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
